import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class PaymentDebtAdd extends Component {

  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_id: '',
      staff_id: '',
      daily_currency: '',
      training_selected: 0,
      daily_value: 1,
      daily_paid: 1,
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [
        {value: "EUR", label: "Euro"},
        {value: "USD", label: "Dólar"},
        {value: "BRL", label: "Real"},
      ],
      mission_types_select: [
        { value: 'daily', label: 'Diárias' },
        { value: 'base_chief', label: 'Representante Operacional' },
        { value: 'transport', label: 'Transporte' },
        { value: 'distance', label: 'Deslocamento' },
      ],
      training_types_select: [
        { value: 'hour', label: 'Horas' },
        { value: 'daily', label: 'Diárias' },
        { value: 'check', label: 'Cheques' },
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleSelectChangeTraining = this.handleSelectChangeTraining.bind(this);

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }


  handleSelectChangeSchedule(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState({training_id: null, type: null, reference: 'schedule'});
    this.setState(change);
  }
  handleSelectChangeTraining(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState({schedule_grade_id: null, type: null, reference: 'training'});
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/lista/completo';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({schedule_grades_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamentos/codigos/lista/completo';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({trainings_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      staff_id: this.state.staff_id,
      schedule_grade_id: this.state.schedule_grade_id,
      training_id: this.state.training_id,
      type: this.state.type,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/saldo/devedor/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/pagamentos/saldo/debito/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Adicionar saldo devedor</h3>
      <Link to="/saldo/devedor" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Tripulante:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                placeholder={'Selecionar tripulante'}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.staffs_list}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Escala / Grade:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_id"
                value={this.state.schedule_grade_id}
                searchable={true}
                placeholder={'Selecionar escala'}
                onChange={this.handleSelectChangeSchedule.bind(this, 'schedule_grade_id')}
                options={this.state.schedule_grades_list}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Treinamento:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={'Selecionar treinamento'}
                onChange={this.handleSelectChangeTraining.bind(this, 'training_id')}
                options={this.state.trainings_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>Valor total:</label>
              <input value={this.state.daily_total} name="daily_total" className="form-control" onChange={this.handleChange.bind(this, 'daily_total')} placeholder="" required/>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Diária moeda:</label>
              <Select
                className="form-field-name"
                name="daily_currency"
                value={this.state.daily_currency}
                placeholder={'Selecionar moeda'}
                onChange={this.handleSelectChange.bind(this, 'daily_currency')}
                options={this.state.daily_currency_list}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>Tipo de Débito:</label>
              {
                this.state.reference === 'schedule' ?
                <Select
                  className=""
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={this.state.mission_types_select}
                  required
                />
                :
                <Select
                  className=""
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={this.state.training_types_select}
                  required
                />
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentDebtAdd;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentDebtAdd.js